import * as React from 'react';

import { ChatModal } from '../../components/ChatModal';
import { useChatContext } from '../../context';
import { useOfferContext } from '../OfferContext';

export const ChatModalContainer: React.FC = () => {
  const { offerWithChat, defaultMessage, closeChat } = useChatContext();
  const {
    id,
    dealType,
    offerType,
    gaLabel,
    tracking: { onChatPopupOpen },
  } = useOfferContext();

  const chatUrl = React.useMemo(() => {
    if (offerWithChat !== id) {
      return null;
    }

    onChatPopupOpen();

    return (
      `/dialogs/?hostType=frame&offerId=${id}` +
      `&dealType=${dealType}&offerType=${offerType}` +
      `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
      `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
      '&pageType=CardHS'
    );
  }, [dealType, defaultMessage, gaLabel, id, offerType, offerWithChat, onChatPopupOpen]);

  if (!chatUrl) {
    return null;
  }

  return <ChatModal iframeSrc={chatUrl} isOpen onClose={closeChat} />;
};
